import React from 'react';
import LoaderIcon from '../common/icons/loader-icon';

const Loading = () => (
  <div
    data-testid="auth_loading"
    className="spinner w-100 d-flex justify-content-center align-items-center h-100 vh-100"
  >
    <LoaderIcon />
  </div>
);

export default Loading;
